import { WrenchIcon } from './WrenchIcon';

/**
 * author: Google
 * id CACAAE64-D38D-423E-8C84-68EFF0EA0F8A
 * name wrench
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wrench.svg
 * tags
 * - Hardware / Tools 
 */
export const BuildIcon = WrenchIcon;
export default BuildIcon